module.exports = __webpack_public_path__ + "static/media/flag-ru.faa310fd.webp";